<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yoU5CC/tc-custom/9780253063540.jpg?1721453849650" alt="This image is the cover for the book Conamara Chronicles, Irish Culture, Memory, Place"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Conamara Chronicles, Irish Culture, Memory, Place
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"I find him to be a kindred spirit, a sympathetic but shrewd enquirer, a companionable stroller, and a lover of anecdotes gathered by the wayside." </b></p><p>So Tim Robinson described folklorist, revolutionary, and district justice Seán Mac Giollarnáth, whose 1941 book <i>Annála Beaga ó Iorras Aithneach </i>revealed his sheer delight in the rich language and stories of the people he encountered in Conamara, the Irish-speaking region in the south of Connemara. From tales of smugglers, saints, and scholars to memories of food, work, and family, the stories gathered here provide invaluable insights into the lives and culture of the community. This faithful and lovingly crafted translation, complete with annotations, a biography, and thoughtful chapters that explore the importance of the language and region, is the final work of both Robinson and his collaborator, the renowned writer and Irish language expert Liam Mac Con Iomaire. </p><p>Translated into English for the first time, <i>Conamara Chronicles: Tales from Iorras Aithneach </i>preserves the art of storytellers in the West of Ireland and honors the inspiration they kindle even still. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Seán Mac Giollarnáth, Liam Mac Con Iomaire, Tim Robinson
      </h2>
      
      <p class="authorDescription body article"><P><B><P>Seán Mac Giollarnáth</B> (1880–1970) was a writer, judge, and folklore collector in his native County Galway. A key figure in the Irish cultural revival, he combined a long career as a district justice with the compilation of folktales and traditional lore from collaborators in Conamara and beyond.</P><B><P>Liam Mac Con Iomaire</B> (1937–2019) was a teacher, journalist, and writer from Casla, County Galway. Major publications include biographies of Breandán Ó hEithir, Seosamh Ó hÉanaí, and, in collaboration with Tim Robinson, <I>Graveyard Clay</I>, the translation of Máirtín Ó Cadhain's 1949 novel <I>Cré na Cille</I>. He was an acknowledged authority on Irish language usage and traditional singing in Irish.</P><B><P>Tim Robinson </B>(1935–2020) was born in Yorkshire, studied mathematics at Cambridge, and worked as a visual artist in Istanbul, Vienna, and London. He moved to the Aran Islands in 1972 and commenced a multidecade project of mapping and writing about Aran, the Burren, and Connemara. He was author of the two-volume <I>Stones of Aran</I> and the Connemara trilogy.</P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eed3ed26